export default {
  appSettings: {
    Account2Config: {
      notificationSettings: {
        shouldShowNotificationSettingsTab: false,
        shouldShowEmail: true,
        shouldShowSms: true,
        shouldShowPhoneCall: true,
        shouldShowTCPA: true
      },
      financingTerms: {
        shouldShowFinancingTermsTab: false
      },
      referrals: {
        shouldShowReferralsTab: false
      }
    }
  },
  getAppSettings: {
    isLoading: false,
    error: {}
  }
};
